/*
 *
 * sort helper:
 * ------------
 * gather when possible all sort in the codebase
 * to scope the sort function to the helper
 * to ease maintainance and natural sort
 *
 */

export const ASC = 'asc';
export const DESC = 'desc';

const isAsc = d => d === ASC;

// plain comparators (like R.ascend / R.descend)
const ascendCmp = (a, b) => (a < b ? -1 : a > b ? 1 : 0);
const descendCmp = (a, b) => (a > b ? -1 : a < b ? 1 : 0);

// natural, locale + numeric aware comparators (like R.ascendNatural / R.descendNatural)
const naturalCmp = (locale, sign) => (a, b) =>
  sign * String(a).localeCompare(String(b), locale, { numeric: true });

// pluck prop p then apply the optional list of transforms t (like R.pipe(R.prop(p), ...t))
const transducer =
  (p, t = []) =>
  value =>
    t.reduce((v, fn) => fn(v), value?.[p]);

const byProp = (p, d, t) => {
  const get = transducer(p, t);
  const base = isAsc(d ?? ASC) ? ascendCmp : descendCmp;
  return (a, b) => base(get(a), get(b));
};

const byNaturalProp = (p, l = 'en', d, t) => {
  const get = transducer(p, t);
  const cmp = naturalCmp(l, isAsc(d ?? ASC) ? 1 : -1);
  return (a, b) => cmp(get(a), get(b));
};

const sortByNatural = (p, l, d, t) => list => [...list].sort(byNaturalProp(p, l, d, t));
const sortBy = (p, d, t) => list => [...list].sort(byProp(p, d, t));

export const sortByProp = p => list => [...list].sort(byProp(p, ASC));
export const sortByIndex = sortByProp('index');
export const sortByLabel = (l, d, t) => sortByNatural('label', l, d, t);

export const sortByNumberId = d => sortBy('id', d, [Number]);

export const sortByOrderAndLabel = l => list => {
  const comparators = [byProp('order'), byNaturalProp('label', l)];
  return [...list].sort((a, b) => {
    for (const cmp of comparators) {
      const res = cmp(a, b);
      if (res !== 0) return res;
    }
    return 0;
  });
};
